document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    "#shopify-section-template--15385620316240__featured_collections_jVbpQJ .button, #shopify-section-template--15385620316240__featured_collections_QNFnUX .button"
  );

  buttons.forEach((btn) => {
    // Обернуть текст в <span>, если ещё не обёрнут
    if (!btn.querySelector("span")) {
      const span = document.createElement("span");
      span.innerHTML = btn.innerHTML;
      btn.innerHTML = "";
      btn.appendChild(span);
    }

    // Добавить кастомный класс для стилей
    btn.classList.add("custom-hover-button");

    // Прямое управление цветом текста через JS (обход inline-style Shopify)
    btn.addEventListener("mouseenter", () => {
      btn.style.color = "#5a3e2b";
    });
    btn.addEventListener("mouseleave", () => {
      btn.style.color = "white";
    });
  });
});